var React = require('react');

function IconFilter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.66667 8H7.33333V6.66667H4.66667V8ZM0 0V1.33333H12V0H0ZM2 4.66667H10V3.33333H2V4.66667Z"}));
}

IconFilter.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = IconFilter;

IconFilter.default = IconFilter;
